import { AppointmentType } from "@/shared/models/appointment";

/** How care is delivered, independent of the scheduling channel (Voice, SMS or Web). */
export enum CareMode {
  IN_PERSON = "in_person",
  TELEHEALTH = "telehealth",
}

/** Compatibility for source slot types that do not carry a separate care-delivery mode. */
export function appointmentTypeCareMode(appointmentType: AppointmentType): CareMode {
  return appointmentType === AppointmentType.TELEHEALTH ? CareMode.TELEHEALTH : CareMode.IN_PERSON;
}
